<div class="preview-table">
  <table>
    <thead>
      <tr class="border-bottom">
        <th class="header-text row-number-header" i18n>Row</th>
        <th *ngFor="let column of columns" class="header-text">
          <img
            *ngIf="(columnErrors$ | async)?.columnErrors[column]?.hasError"
            src="assets/icons/light/Circle-Error.svg"
            [style.margin-right.rem]="0.25"
            alt="Error"
            i18n-alt />
          {{ column !== 'SIN' ? (column | humanReadable) : column }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rec of recordsToDisplay$ | async; let first = first">
        <td class="row-column">
          {{ rec['ROW_NUMBER'] }}
        </td>
        <td class="last-name-column" [class.error]="!rec['LAST NAME']">
          {{ rec['LAST NAME'] }}
        </td>
        <td class="first-name-column" [class.error]="!rec['FIRST NAME']">
          {{ rec['FIRST NAME'] }}
        </td>
        <td class="dob-column" [class.error]="!rec['DATE_OF_BIRTH']">
          {{ rec['DATE_OF_BIRTH'] ? (rec['DATE_OF_BIRTH'] | date : 'MMM dd, yyyy') : null }}
        </td>
        <td class="sin-column" [class.error]="!rec?.SIN">
          <app-sin-display-field [sin]="rec?.SIN?.toString(10) ?? null" />
        </td>
        <td class="email-column" [class.error]="!rec['EMAIL']">
          {{ rec['EMAIL'] }}
        </td>
        <td class="employment-start-column" [class.error]="!rec['EMPLOYMENT_START']">
          {{ rec['EMPLOYMENT_START'] ? (rec['EMPLOYMENT_START'] | date : 'MMM dd, yyyy') : null }}
        </td>
      </tr>
    </tbody>
  </table>
  <div class="extra-rows-container" *ngIf="records.length > 5">
    <span class="extra-rows" i18n>+ {{ records.length - 5 }} more rows</span>
  </div>
</div>
